export default "__VITE_ASSET__C56aIjsC__"